// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'plus-between-left-column';

export const Component = () => (
  <path d='M8.813 5.885v3.928h1.005V5.885h3.927v-.958H9.818V1H8.813v3.927H4.885v.958h3.928Zm15.708 0h-.958V22.6H15.71v-9.052h-1.006V22.6H.958V5.885H0v17.673h24.521V5.885Z' />
);

export const viewBox = '0 0 25 25';
